import { default as Space } from 'antd/es/space';
import { useMemo } from 'react';

import { TertiaryButton } from '@atoms/buttons/TertiaryButton';

import { LocalDateRangeWrapper } from '@molecules/LocalDateRangeWrapper';
import { SelectVirtualAccount } from '@molecules/SelectVirtualAccount';

import type { FiltersState } from './localState';

import { EXPORTED_PAYINS_ACCOUNTS_FILTER_TEST_ID } from '../constants';

type ExportedPayinsFiltersProps = {
  filters: FiltersState;
  setFilters: (value: FiltersState) => void;
  resetState: () => void;
};

export const ExportedPayinsFilters = ({
  filters,
  setFilters,
  resetState
}: ExportedPayinsFiltersProps) => {
  const hasFilters = useMemo(
    () =>
      Object.values(filters).some((value) => Boolean(value) && value !== 'All'),
    [filters]
  );

  return (
    <div className="flex items-center">
      <Space wrap size="small">
        <LocalDateRangeWrapper />
        <SelectVirtualAccount
          onChangeCallback={(virtualAccountNumber) => {
            setFilters({ virtualAccountNumber });
          }}
          currentAccountNumber={filters.virtualAccountNumber}
          e2eId={EXPORTED_PAYINS_ACCOUNTS_FILTER_TEST_ID}
          filterCryptoAccounts={true}
        />
        {hasFilters && (
          <TertiaryButton className="h-10 font-semibold" onClick={resetState}>
            Clear filters
          </TertiaryButton>
        )}
      </Space>
    </div>
  );
};
